import * as api_config from '../config/api_config'

export default {
  getProducts (axios, path = null, config = {}, params = {}) {
    let location = path || '/products'
    return axios.get(`${api_config.ADDRESS}${location}`, { params, headers: api_config.HEADERS, ...config})
  },
  getFilters (axios) {
    return axios.get(`${api_config.ADDRESS}/products/filters`, { headers: api_config.HEADERS})
  },
  getEstimatedDelivery (axios, slug, params) {
    const url = `${api_config.ADDRESS}/products/${slug}/estimated_delivery`
    const options = { params, headers: api_config.HEADERS }

    return axios.get(url, options)
  }
}
